import React, { FC, useState, useEffect } from 'react';
import { fetchEnterpriseInfos } from '../../enterprise.api';
import { EnterpriseCard } from './EnterpriseCard';
import { PopoverWrapper } from '../../../components/popovers/wrapper/PopoverWrapper';
import { PopoverLoading } from '../../../components/popovers/loading/PopoverLoading';
import { delayPromise } from '../../../utils/promise';
import { doctrineAnalytics } from '../../../utils/analyticsUtils';
import { EnterprisePopoverInfos } from './enterprisePopover.types';

type Props = {
  siren: string;
  source: string;
};

export const EnterprisePopover: FC<Props> = ({ siren, source }) => {
  const [
    enterpriseInfos,
    setEnterpriseInfos,
  ] = useState<EnterprisePopoverInfos | null>(null);
  const [isLoading, setLoading] = useState(false);

  useEffect(() => {
    async function fetch() {
      setLoading(true);

      const { data } = await delayPromise(fetchEnterpriseInfos(siren), 300);
      doctrineAnalytics('DisplayEnterprisePopover');
      setEnterpriseInfos(data);
      setLoading(false);
    }

    fetch();
  }, [siren]);

  if (isLoading)
    return (
      <PopoverWrapper>
        <PopoverLoading />
      </PopoverWrapper>
    );

  if (!enterpriseInfos) return null;

  return (
    <PopoverWrapper>
      <EnterpriseCard enterprise={enterpriseInfos} source={source} />
    </PopoverWrapper>
  );
};
